// extracted by mini-css-extract-plugin
export default {"passwordRequirements":"passwordRequirements--OLCVg"};